module.exports = __webpack_public_path__ + "instacart-049a7d29.png";